// extracted by mini-css-extract-plugin
export default {"otpInput":"ResetPasswordForm_otpInput__pVUF5","submitButton":"ResetPasswordForm_submitButton__oBKKt"};